// extracted by mini-css-extract-plugin
module.exports = {"intro":"Home_intro_2zOQV"};